import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import PrintLayout from '../Layouts/PrintLayout';
import ReactDOMServer from 'react-dom/server';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import RevisionHxPrint from './RevisionHxPrint';
import { useSelector } from 'react-redux';

function RevisionHxListPopup({
  soapId,
  patientId,
  appId,
  visitId,
  handleClose,
  dataForPrint,
}) {
  const [allData, setAllData] = useState([]);
  const { user } = useSelector((state) => state.auth);
  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/revisionHxPopUp',
          {
            soapId: soapId,
            patientId: patientId,
          }
        );
        if (response?.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [soapId, patientId]);

  const openPrintWindow = (printContent) => {
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(printContent);
    printWindow.document.close(); // Ensure the content is ready for print
    printWindow.focus();
    printWindow.print();
  };

  const getPrintContent = (data) => {
    const { noteType, printHeaderFooterInfo, visitType } = data;

    const layout = (
      <PrintLayout headerFooterInfo={printHeaderFooterInfo}>
        {noteType === '3' ? (
          <RevisionHxPrint allData={data} template={visitType} />
        ) : (
          noteType === '2' && ''
        )}
      </PrintLayout>
    );

    let printContent = ReactDOMServer.renderToString(layout);
    printContent = `
    <html>
      <head>
        <link rel="stylesheet" type="text/css" href="${DEFAULT_LOCAL_PATH}/styleprint.css">
      </head>
      <body>${printContent}</body>
    </html>
  `;
    return printContent;
  };

  const handlePrint = async (revHxId) => {
    try {
      if (!patientId || !appId || !visitId || !revHxId) return;

      const response = await post(
        'api/patient/progressNote/printPatientRevHxSoapNote',
        {
          userloginId: user?.id,
          patientId: patientId,
          revHxId,
        }
      );
      if (response?.status === 200) {
        const contentToPrint = getPrintContent(response?.data); // Assuming `data` is the object you pass in
        openPrintWindow(contentToPrint);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="past-appointment slide-down" id="revHxContainer">
        <div className="main-div-container-for-listApp">
          <div className="main-header">
            <span className="info-header">
              {allData?.patName} (#{allData?.chart_number}) :{' '}
              <span className="appointment-type">Revision History</span>
            </span>
            <span
              className="btn_close"
              onClick={handleClose}
              style={{ cursor: 'pointer' }}
            >
              X
            </span>
          </div>
          <div className="header-for-table">
            <div className="first-column-listOf header-text">
              Date/Time
              <span className="sep right">|</span>
            </div>
            <div className="first-column-listOf header-text">
              Provider
              <span className="sep right">|</span>
            </div>
            <div
              className="second-column-listOf header-text"
              style={{ width: '180px' }}
            >
              Counselor
              <span className="sep right">|</span>
            </div>
            <div
              className="second-column-listOf header-text"
              style={{ width: '200px' }}
            >
              Status
              <span className="sep right">|</span>
            </div>
            <div
              className="third-column-listOf header-text"
              style={{ width: '130px' }}
            >
              Action
            </div>
          </div>
          <div className="row-data-container">
            {allData?.revHxList &&
              allData?.revHxList.length > 0 &&
              allData?.revHxList.map((item, i) => {
                return (
                  <div key={i} className="row-for-listOf even-row-for-list">
                    <div className="first-column-listOf">
                      {item?.addedDate}
                      <br />
                      {item?.addedTime}
                    </div>
                    <div className="first-column-listOf">
                      {item?.providerName}
                    </div>
                    <div
                      className="second-column-listOf"
                      style={{ width: '180px' }}
                    >
                      <span className="status-type">
                        <div className="row-space text_light_black">
                          {item?.counsellorName}
                        </div>
                      </span>
                    </div>
                    <div
                      className="second-column-listOf "
                      style={{ width: '200px' }}
                    >
                      <span className="status-type">
                        <div className="row-space text_light_black">
                          {item?.revHxStatus}
                        </div>
                      </span>
                    </div>
                    <div
                      className="third-column-listOf "
                      style={{ width: '130px' }}
                    >
                      <div className="all-options">
                        <div
                          className="optionFirst"
                          onClick={() => handlePrint(item?.revHxId)}
                        >
                          <Link>Print Hx</Link>
                        </div>
                        <div className="optionThird"></div>
                      </div>
                    </div>
                  </div>
                );
              })}
            {/* <div className="row-for-listOf even-row-for-list">
              <div className="first-column-listOf ">
                07-31-2024
                <br />
                06:27 pm
              </div>
              <div className="first-column-listOf ">Devra Sara Gordon</div>
              <div className="second-column-listOf " style={{ width: '180px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="second-column-listOf " style={{ width: '200px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Signed by Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="third-column-listOf " style={{ width: '130px' }}>
                <div className="all-options">
                  <div className="optionFirst">
                    <Link href="#">Print Hx</Link>
                  </div>
                  <div className="optionThird"></div>
                </div>
              </div>
            </div>
            <div className="row-for-listOf odd-row-for-list">
              <div className="first-column-listOf ">
                07-31-2024
                <br />
                06:28 pm
              </div>
              <div className="first-column-listOf ">Devra Sara Gordon</div>
              <div className="second-column-listOf " style={{ width: '180px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="second-column-listOf " style={{ width: '200px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Signed by Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="third-column-listOf " style={{ width: '130px' }}>
                <div className="all-options">
                  <div className="optionFirst">
                    <Link href="#">Print Hx</Link>
                  </div>
                  <div className="optionThird"></div>
                </div>
              </div>
            </div>
            <div className="row-for-listOf even-row-for-list">
              <div className="first-column-listOf ">
                07-31-2024
                <br />
                08:38 pm
              </div>
              <div className="first-column-listOf ">Devra Sara Gordon</div>
              <div className="second-column-listOf " style={{ width: '180px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="second-column-listOf " style={{ width: '200px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Signed by Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="third-column-listOf " style={{ width: '130px' }}>
                <div className="all-options">
                  <div className="optionFirst">
                    <Link href="#">Print Hx</Link>
                  </div>
                  <div className="optionThird"></div>
                </div>
              </div>
            </div>
            <div className="row-for-listOf odd-row-for-list">
              <div className="first-column-listOf ">
                07-31-2024
                <br />
                08:39 pm
              </div>
              <div className="first-column-listOf ">Devra Sara Gordon</div>
              <div className="second-column-listOf " style={{ width: '180px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="second-column-listOf " style={{ width: '200px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Signed by Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="third-column-listOf " style={{ width: '130px' }}>
                <div className="all-options">
                  <div className="optionFirst">
                    <Link>Print Hx</Link>
                  </div>
                  <div className="optionThird"></div>
                </div>
              </div>
            </div>
            <div className="row-for-listOf odd-row-for-list">
              <div className="first-column-listOf ">
                07-31-2024
                <br />
                08:39 pm
              </div>
              <div className="first-column-listOf ">Devra Sara Gordon</div>
              <div className="second-column-listOf " style={{ width: '180px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="second-column-listOf " style={{ width: '200px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Signed by Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="third-column-listOf " style={{ width: '130px' }}>
                <div className="all-options">
                  <div className="optionFirst">
                    <Link>Print Hx</Link>
                  </div>
                  <div className="optionThird"></div>
                </div>
              </div>
            </div>
            <div className="row-for-listOf odd-row-for-list">
              <div className="first-column-listOf ">
                07-31-2024
                <br />
                08:39 pm
              </div>
              <div className="first-column-listOf ">Devra Sara Gordon</div>
              <div className="second-column-listOf " style={{ width: '180px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="second-column-listOf " style={{ width: '200px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Signed by Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="third-column-listOf " style={{ width: '130px' }}>
                <div className="all-options">
                  <div className="optionFirst">
                    <Link>Print Hx</Link>
                  </div>
                  <div className="optionThird"></div>
                </div>
              </div>
            </div>
            <div className="row-for-listOf odd-row-for-list">
              <div className="first-column-listOf ">
                07-31-2024
                <br />
                08:39 pm
              </div>
              <div className="first-column-listOf ">Devra Sara Gordon</div>
              <div className="second-column-listOf " style={{ width: '180px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="second-column-listOf " style={{ width: '200px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Signed by Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="third-column-listOf " style={{ width: '130px' }}>
                <div className="all-options">
                  <div className="optionFirst">
                    <Link>Print Hx</Link>
                  </div>
                  <div className="optionThird"></div>
                </div>
              </div>
            </div>
            <div className="row-for-listOf odd-row-for-list">
              <div className="first-column-listOf ">
                07-31-2024
                <br />
                08:39 pm
              </div>
              <div className="first-column-listOf ">Devra Sara Gordon</div>
              <div className="second-column-listOf " style={{ width: '180px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="second-column-listOf " style={{ width: '200px' }}>
                <span className="status-type">
                  <div className="row-space text_light_black">
                    Signed by Devra Sara Gordon
                  </div>
                </span>
              </div>
              <div className="third-column-listOf " style={{ width: '130px' }}>
                <div className="all-options">
                  <div className="optionFirst">
                    <Link>Print Hx</Link>
                  </div>
                  <div className="optionThird"></div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RevisionHxListPopup;
